import React, { PureComponent } from 'react';
import Select from 'react-dropdown-select';

class SchedulePost extends PureComponent {
  constructor(props) {
    super(props);
    this.hrsRef = React.createRef();
    this.minsRef = React.createRef();

    this.setHours = this.setHours.bind(this);
    this.setMonth = this.setMonth.bind(this);
    this.setMins = this.setMins.bind(this);

    this.state = {
      monthsList: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      dayList: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
      dates: [],
      scheduleDate: null,
      choosedDate: 0,
      selectedMonth: 0,
      selectedYear: new Date().getFullYear(),
      selectedDate: 0,
      selectedDay: '',
      selectedHour: 12,
      selectedMinutes: '00',
      selectedAMPM: null,
      twelveHours: 12,
      title: null,
      btnTitle: 'OK',

      ampmOptions: [
        {
          id: '0',
          title: 'AM',
          value: 'am',
        },
        {
          id: '1',
          title: 'PM',
          value: 'pm',
        },
      ],
      monthValues: [],
      selectedMonthValue: [],
    };
  }

  buildMonthList(selectedYear, selectedMonth) {
    try {
      const now = new Date();
      let startYear = now.getFullYear();
      let startMonth = now.getMonth();

      if (
        selectedYear < startYear ||
        (selectedYear === startYear && selectedMonth < startMonth)
      ) {
        startYear = selectedYear;
        startMonth = selectedMonth;
      }

      const monthList = [];
      let curMonth = startMonth;
      let curYear = startYear;

      for (let i = 0; i < 24; i++) {
        monthList.push({
          id: i,
          title: this.state.monthsList[curMonth] + ' - ' + curYear,
          month: this.state.monthsList[curMonth],
          monthIndex: curMonth,
          year: curYear,
        });
        curMonth++;
        if (curMonth > 11) {
          curMonth = 0;
          curYear++;
        }
      }
      return monthList;
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  generateDatesList(year, month) {
    try {
      const daysInCurrentMonth = new Date(year, month + 1, 0).getDate();
      const daysInPrevMonth = new Date(year, month, 0).getDate();
      const firstDayOfWeek = new Date(year, month, 1).getDay();

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const datesList = [];
      let id = 0;

      // Trailing days of previous month
      for (let i = firstDayOfWeek - 1; i >= 0; i--) {
        const d = daysInPrevMonth - i;
        const prevMonth = month === 0 ? 11 : month - 1;
        const prevYear = month === 0 ? year - 1 : year;
        const dayOfWeek = new Date(prevYear, prevMonth, d).getDay();
        datesList.push({
          id: id++,
          monthOf: 'previous',
          date: d,
          month: prevMonth,
          year: prevYear,
          day: dayOfWeek,
          active: false,
          isCurrentDate: false,
        });
      }

      // Days of current month
      for (let d = 1; d <= daysInCurrentMonth; d++) {
        const cellDate = new Date(year, month, d, 0, 0, 0, 0);
        const dayOfWeek = cellDate.getDay();
        const isActive = cellDate >= today;
        const isCurrentDate = cellDate.getTime() === today.getTime();

        datesList.push({
          id: id++,
          monthOf: 'current',
          date: d,
          month: month,
          year: year,
          day: dayOfWeek,
          active: isActive,
          isCurrentDate: isCurrentDate,
        });
      }

      // Leading days of next month
      let nextDate = 1;
      while (datesList.length < 42) {
        const nextMonth = month === 11 ? 0 : month + 1;
        const nextYear = month === 11 ? year + 1 : year;
        const dayOfWeek = new Date(nextYear, nextMonth, nextDate).getDay();
        datesList.push({
          id: id++,
          monthOf: 'next',
          date: nextDate++,
          month: nextMonth,
          year: nextYear,
          day: dayOfWeek,
          active: false,
          isCurrentDate: false,
        });
      }

      return datesList;
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  initDate(val) {
    try {
      const parsed = val ? new Date(val) : new Date();
      const d = isNaN(parsed.getTime()) ? new Date() : parsed;
      d.setSeconds(0);
      d.setMilliseconds(0);

      const year = d.getFullYear();
      const month = d.getMonth();
      const date = d.getDate();
      const hour24 = d.getHours();
      const minutes = d.getMinutes();

      const isPM = hour24 >= 12;
      const ampmObj = isPM
        ? this.state.ampmOptions[1]
        : this.state.ampmOptions[0];
      const twelve =
        hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
      const formattedMins = minutes < 10 ? '0' + minutes : String(minutes);

      const monthList = this.buildMonthList(year, month);
      const matchedMonth = monthList.find(
        (item) => item.monthIndex === month && item.year === year,
      ) || monthList[0];

      const datesList = this.generateDatesList(year, month);

      this.setState({
        monthValues: monthList,
        selectedMonthValue: [matchedMonth],
        selectedMonth: month,
        selectedYear: year,
        selectedDate: date,
        selectedDay: this.state.dayList[d.getDay()].slice(0, 3),
        selectedHour: hour24,
        twelveHours: twelve,
        selectedMinutes: formattedMins,
        selectedAMPM: [ampmObj],
        scheduleDate: d,
        dates: datesList,
        btnTitle: this.props.btnTitle ? this.props.btnTitle : 'OK',
        title: this.props.title ? this.props.title : null,
      });
    } catch (error) {
      console.log(error);
    }
  }

  componentDidMount() {
    this.initDate(this.props.value);
  }

  componentDidUpdate(prevProps) {
    const prevTime = prevProps.value
      ? new Date(prevProps.value).getTime()
      : null;
    const currTime = this.props.value
      ? new Date(this.props.value).getTime()
      : null;
    if (prevTime !== currTime) {
      this.initDate(this.props.value);
    }
    if (prevProps.title !== this.props.title) {
      this.setState({
        title: this.props.title ? this.props.title : null,
      });
    }
    if (prevProps.btnTitle !== this.props.btnTitle) {
      this.setState({
        btnTitle: this.props.btnTitle ? this.props.btnTitle : 'OK',
      });
    }
  }

  setHours(e) {
    try {
      const raw = e.target.value.trim();
      if (raw.length === 0) {
        this.setState({
          twelveHours: '',
          selectedHour: null,
        });
        return;
      }

      const val = parseInt(raw, 10);
      if (isNaN(val) || val < 1 || val > 12) {
        return;
      }

      const isPM =
        this.state.selectedAMPM &&
        this.state.selectedAMPM[0] &&
        this.state.selectedAMPM[0].value === 'pm';
      let hour24;
      if (isPM) {
        hour24 = val === 12 ? 12 : val + 12;
      } else {
        hour24 = val === 12 ? 0 : val;
      }

      const scheduleDate = new Date(this.state.scheduleDate || new Date());
      scheduleDate.setHours(hour24);
      scheduleDate.setMinutes(parseInt(this.state.selectedMinutes, 10) || 0);
      scheduleDate.setSeconds(0);
      scheduleDate.setMilliseconds(0);

      this.setState({
        twelveHours: val,
        selectedHour: hour24,
        scheduleDate: scheduleDate,
      });
    } catch (error) {
      console.log(error);
    }
  }

  setMins(e) {
    try {
      const raw = e.target.value.trim();
      if (raw.length === 0) {
        this.setState({
          selectedMinutes: '',
        });
        return;
      }

      const val = parseInt(raw, 10);
      if (isNaN(val) || val < 0 || val > 59) {
        return;
      }

      const formatted =
        raw.length === 1 ? raw : val < 10 ? '0' + val : String(val);

      const scheduleDate = new Date(this.state.scheduleDate || new Date());
      scheduleDate.setMinutes(val);
      scheduleDate.setSeconds(0);
      scheduleDate.setMilliseconds(0);

      this.setState({
        selectedMinutes: formatted,
        scheduleDate: scheduleDate,
      });
    } catch (error) {
      console.log(error);
    }
  }

  setAMPM(val) {
    try {
      if (!val || !val[0]) return;
      const isPM = val[0].value === 'pm';
      const twelve = this.state.twelveHours
        ? parseInt(this.state.twelveHours, 10)
        : 12;

      let hour24;
      if (isPM) {
        hour24 = twelve === 12 ? 12 : twelve + 12;
      } else {
        hour24 = twelve === 12 ? 0 : twelve;
      }

      const scheduleDate = new Date(this.state.scheduleDate || new Date());
      scheduleDate.setHours(hour24);
      scheduleDate.setMinutes(parseInt(this.state.selectedMinutes, 10) || 0);
      scheduleDate.setSeconds(0);
      scheduleDate.setMilliseconds(0);

      this.setState({
        selectedAMPM: val,
        selectedHour: hour24,
        twelveHours: twelve,
        scheduleDate: scheduleDate,
      });
    } catch (error) {
      console.log(error);
    }
  }

  setMonth(obj) {
    try {
      if (!obj || !obj[0]) return;
      const selectedMonth =
        obj[0].monthIndex !== undefined
          ? obj[0].monthIndex
          : this.state.monthsList.indexOf(obj[0].month);
      const selectedYear = obj[0].year;

      const maxDays = new Date(selectedYear, selectedMonth + 1, 0).getDate();
      let currentDate = this.state.selectedDate || 1;
      if (currentDate > maxDays) {
        currentDate = maxDays;
      }

      const datesList = this.generateDatesList(selectedYear, selectedMonth);

      const scheduleDate = new Date(this.state.scheduleDate || new Date());
      scheduleDate.setDate(1);
      scheduleDate.setFullYear(selectedYear);
      scheduleDate.setMonth(selectedMonth);
      scheduleDate.setDate(currentDate);
      scheduleDate.setHours(this.state.selectedHour);
      scheduleDate.setMinutes(parseInt(this.state.selectedMinutes, 10) || 0);
      scheduleDate.setSeconds(0);
      scheduleDate.setMilliseconds(0);

      const dayName = this.state.dayList[scheduleDate.getDay()].slice(0, 3);

      this.setState({
        selectedMonthValue: obj,
        selectedMonth: selectedMonth,
        selectedYear: selectedYear,
        selectedDate: currentDate,
        selectedDay: dayName,
        dates: datesList,
        scheduleDate: scheduleDate,
      });
    } catch (error) {
      console.log(error);
    }
  }

  selectDate(obj) {
    try {
      if (!obj.active || obj.monthOf !== 'current') {
        return;
      }

      const scheduleDate = new Date(this.state.scheduleDate || new Date());
      scheduleDate.setFullYear(obj.year);
      scheduleDate.setMonth(obj.month);
      scheduleDate.setDate(obj.date);
      scheduleDate.setHours(this.state.selectedHour);
      scheduleDate.setMinutes(parseInt(this.state.selectedMinutes, 10) || 0);
      scheduleDate.setSeconds(0);
      scheduleDate.setMilliseconds(0);

      const dayName = this.state.dayList[scheduleDate.getDay()].slice(0, 3);

      this.setState({
        selectedDate: obj.date,
        selectedMonth: obj.month,
        selectedYear: obj.year,
        selectedDay: dayName,
        choosedDate: obj.date,
        scheduleDate: scheduleDate,
      });
    } catch (error) {
      console.log(error);
    }
  }

  setDateClass(item) {
    let classes = '';

    if (item.monthOf === 'previous') {
      classes += ' previousMonthDate disabled ';
    } else if (item.monthOf === 'next') {
      classes += ' nextMonthDate disabled ';
    } else {
      if (item.active) {
        classes += ' active ';
      } else {
        classes += ' disabled ';
      }
    }

    if (item.isCurrentDate) {
      classes += ' current ';
    }

    const isSelected =
      this.state.scheduleDate &&
      item.monthOf === 'current' &&
      item.date === this.state.scheduleDate.getDate() &&
      item.month === this.state.scheduleDate.getMonth() &&
      item.year === this.state.scheduleDate.getFullYear();

    if (isSelected) {
      classes += ' selected ';
    }

    return classes.trim();
  }

  getSemiMonth(val) {
    try {
      return this.state.monthsList[val]
        ? this.state.monthsList[val].slice(0, 3)
        : '';
    } catch (err) {
      console.log(err);
      return '';
    }
  }

  hidePanel = (value) => {
    try {
      this.props.onStatus(value);
    } catch (error) {
      console.log(error);
    }
  };

  setSchedulePost() {
    try {
      if (
        this.state.selectedHour === null ||
        this.state.selectedHour === undefined ||
        this.state.twelveHours === ''
      ) {
        this.props.onAlert('Scheduled Hour is required');
        return false;
      }

      const mins = parseInt(this.state.selectedMinutes, 10);
      const minutesVal = isNaN(mins) ? 0 : mins;

      const scheduleDate = new Date(this.state.scheduleDate || new Date());
      scheduleDate.setHours(this.state.selectedHour);
      scheduleDate.setMinutes(minutesVal);
      scheduleDate.setSeconds(0);
      scheduleDate.setMilliseconds(0);

      const now = new Date();
      now.setSeconds(0);
      now.setMilliseconds(0);

      if (scheduleDate < now) {
        this.props.onAlert(
          'Schedule date must not be less than current date and time',
        );
        return false;
      }

      const currentTitle = this.props.title || this.state.title || '';
      let trigger = null;
      if (/start/i.test(currentTitle)) {
        trigger = 'start';
      } else if (/end|close/i.test(currentTitle)) {
        trigger = 'close';
      }

      this.props.onScheduled(scheduleDate, trigger);
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    const { btnTitle, title, twelveHours, selectedMinutes, selectedAMPM } =
      this.state;

    const displayMinutes =
      selectedMinutes !== '' && selectedMinutes !== null && selectedMinutes !== undefined
        ? String(selectedMinutes).padStart(2, '0')
        : '00';

    return (
      <>
        <div id="schedulePicker">
          {title ? <h3>{title}</h3> : ''}
          <div className="calendarConfig">
            <div className="leftConfig">
              <input
                type="text"
                onChange={this.setHours}
                maxLength="2"
                value={
                  twelveHours !== null && twelveHours !== undefined
                    ? String(twelveHours)
                    : ''
                }
                className="hour"
                ref={this.hrsRef}
              />
              <span className="colon">:</span>
              <input
                type="text"
                maxLength="2"
                onChange={this.setMins}
                value={
                  selectedMinutes !== null && selectedMinutes !== undefined
                    ? String(selectedMinutes)
                    : ''
                }
                className="minute"
                ref={this.minsRef}
              />
              {selectedAMPM ? (
                <Select
                  values={selectedAMPM}
                  onChange={(value) => this.setAMPM(value)}
                  options={this.state.ampmOptions}
                  labelField="title"
                  valueField="id"
                  className="selectbox am"
                />
              ) : (
                ''
              )}
            </div>

            <Select
              values={this.state.selectedMonthValue}
              onChange={(value) => this.setMonth(value)}
              options={this.state.monthValues}
              labelField="title"
              valueField="id"
              className="selectbox month"
            />
          </div>
          <div className="displayCalendar">
            <ul className="weeks">
              {this.state.dayList.map((item, index) => (
                <li key={index}>{item.charAt(0)}</li>
              ))}
            </ul>
            <ul className="days">
              {this.state.dates.map((item) => {
                return (
                  <li
                    onClick={() => this.selectDate(item)}
                    key={item.id}
                    className={this.setDateClass(item)}
                    data-month={item.month}
                    data-year={item.year}
                  >
                    <span>{item.date}</span>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="actionControl">
            <div className="leftSide">
              <button
                className="btn btn-secondary"
                onClick={() => this.hidePanel(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => {
                  const currentTitle =
                    this.props.title || this.state.title || '';
                  const trigger = /end|close/i.test(currentTitle)
                    ? 'close'
                    : /start/i.test(currentTitle)
                    ? 'start'
                    : null;
                  this.props.onRemove(trigger);
                }}
              >
                Remove Schedule
              </button>
            </div>
            <div className="rightSide">
              <div className="selectedDate">
                {title != null && title.length > 0 ? (
                  <span>
                    {' '}
                    Your users will{' '}
                    {/end|close/i.test(title) ? 'stop' : 'start'} seeing the
                    poll from{' '}
                  </span>
                ) : (
                  <span>
                    Your users will start seeing the news feed from{' '}
                  </span>
                )}

                <span>{this.state.selectedDay}, </span>
                <span>{this.state.selectedDate} </span>
                {this.getSemiMonth(this.state.selectedMonth)} <span>at </span>
                {twelveHours !== null && twelveHours !== undefined
                  ? twelveHours
                  : 12}
                :
                {displayMinutes}
                {selectedAMPM ? (
                  <span> {selectedAMPM[0].title} </span>
                ) : (
                  ''
                )}
              </div>
              <button
                className="btn btn-dark"
                onClick={() => this.setSchedulePost()}
              >
                {btnTitle}
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default React.memo(SchedulePost);
